import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';
import { TeamMeetingAttendance } from './TeamMeetingAttendance.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { KPF } from '@chancenwerk/master-data-management/kpf/entities/KPF.js';

@Entity()
export class TeamMeeting extends MongoEntity {
  public static override _class = 'TeamMeeting';
  public static override _collectionName = 'team-meetings';

  @validate(nonOptional())
  @Field(type => DateTime)
  public when: Maybe<DateTime>;

  @validate(nonOptional())
  @Field(type => DateTime)
  public until: Maybe<DateTime>;

  @validate(nonOptional())
  @Field(type => String)
  public createdBy: Maybe<string>;

  @Field(type => String)
  public comment: Maybe<string>;

  @validate(nonOptional())
  @Field(type => String)
  public kpfId: Maybe<string>;

  @DataLoadedField(type => KPF, ({ kpfId }) => kpfId)
  public kpf: Maybe<KPF>;

  @Field(type => [TeamMeetingAttendance], { default: v => v ?? [] })
  public attendances: Maybe<TeamMeetingAttendance[]>;
}
